export default __webpack_public_path__ + "slices/main/assets/public/media/logo-bar-airbnb@2x.b8a88e7ca39002ac51a6fff787dc5459.png";